const STATUS: Record<string, { label: string; cls: string }> = {
  active: { label: "Active", cls: "bg-emerald-100 text-emerald-800" },
  paused: { label: "Paused", cls: "bg-amber-100 text-amber-800" },
  discontinued: { label: "Discontinued", cls: "bg-slate-200 text-slate-700" },
  pending: { label: "Status unconfirmed", cls: "bg-amber-100 text-amber-800" },
};

export function StatusBadge({ status }: { status: string }) {
  const s = STATUS[status] ?? STATUS.pending;
  return <span className={`inline-flex rounded px-1.5 py-0.5 text-xs font-medium ${s.cls}`}>{s.label}</span>;
}

const fmt = (iso: string) => new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
export type PublicVerification = { status: string; verifiedAt: string | null; nextReviewAt: string | null; warning: boolean };

export function VerificationBadge({ v }: { v: PublicVerification }) {
  if (v.status === "verified" && v.verifiedAt) return <span className="text-xs text-emerald-700">Verified {fmt(v.verifiedAt)}</span>;
  if (v.status === "stale") return <span className="text-xs font-medium text-amber-700">Review overdue{v.verifiedAt ? ` · last verified ${fmt(v.verifiedAt)}` : ""}</span>;
  if (v.status === "needs_review") return <span className="text-xs font-medium text-amber-700">Needs review · details may have changed</span>;
  return <span className="text-xs font-medium text-amber-700">Pending verification</span>;
}
